"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 170px;\n  height: 44px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 30px;\n\n  img {\n    & + p {\n      margin-left: 10px;\n    }\n  }\n\n  p {\n    font-family: ", ";\n    font-size: 18px;\n    line-height: 21px;\n    color: #fcfcfc;\n  }\n\n  &:hover {\n    border: 1px solid ", ";\n  }\n"])), _variables.FontFamily.Raleway_700, _variables.GlobalColors.magenta_s2);

exports.Container = Container;